import HistoryResult from "./HistoryResult";

export default HistoryResult;
